import React, { useEffect, useState } from 'react'
import "../Admin.css"
import { DeleteIcon, EditIcon } from '../AdminIcon'
import { Modal, Table } from 'react-bootstrap'
import { RemoveSession } from '../../../Utils/Utils'
import Select from 'react-select';
import AdminDashboard from '../AdminDashboard/AdminDashboard'
import { useNavigate } from 'react-router-dom'
import { checkPattern, customStylesAcc, selectTheme } from '../../../Utils/common'
import { activeInactiveDistrict, addDistrictData, deleteDistrictData, getDistrictListDataSort, getStateDropdown, updateDistrictData } from '../../../services/api/admin'
import { BsChevronLeft } from 'react-icons/bs'
import '../AdminGuidelines/AdminGuildlines.css'
import { HiPlus } from 'react-icons/hi'
import ReactPaginate from 'react-paginate'
import { HomeIcon } from '../../../components/Application/ApplicationIcon'
import { Message } from '../../../components/message'
import { formatDateWithSlash } from '../../../Utils/common'
import NotFoundTable from '../../../components/notFound/NotFoundTable'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { checkPermission , permissionsConfig } from '../AdminPermission/PermissionChecker';
import TotalRecords from '../../../components/notFound/TotalRecords'

const Districts = () => {
    const navigate = useNavigate();
    const [nameEn, setNameEn] = useState('')
    const [nameHi, setNameHi] = useState('')
    const [searchData, setSearchData] = useState('')
    const [sortByDistrict, setSortByDistrict] = useState('created_at')
    const [nameEnError, setNameEnError] = useState()
    const [nameHiError, setNameHiError] = useState()
    const [stateList, setStateList] = useState([])
    const [editSateList, setEditStateList] = useState([])
    const [editStateId, setEditStateId] = useState()
    const [editStateIdError, setEditStateIdError] = useState()
    const [searchState, setSearchState] = useState();
    const [editData, setEditData] = useState()
    const [districtList, setDistrictList] = useState()
    const [tableDataLoaded, setTableDataLoaded] = useState(false)
    const [searchTerm, setSearchTerm] = useState()
    const [deleteData, setDeleteData] = useState()
    const [editContainer, setEditContainer] = useState(false)
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0); // Total number of pages
    const [orderByDistrict, setOrderByDistrict] = useState("desc");
    const [apiMessage, setApiMessage] = useState({ type: '', message: '' });
    const [totalRecords, setTotalRecords] = useState(0);

    const grantPermissionForAddDistrict = checkPermission(permissionsConfig.addDistricts.role, permissionsConfig.addDistricts.action, permissionsConfig.addDistricts.type);
    const grantPermissionForEditDistrict = checkPermission(permissionsConfig.editDistricts.role, permissionsConfig.editDistricts.action, permissionsConfig.editDistricts.type);
    const grantPermissionForDeleteDistrict = checkPermission(permissionsConfig.editDistricts.role, permissionsConfig.editDistricts.action, permissionsConfig.editDistricts.type);

    const handleKeyUpLoginDetails = (item) => {
        validateForm(item);
    };
    //validations
    const validateForm = (item) => {
        let isValid = true;
        if (item === "stateId" || item === "both") {
            if (!editStateId) {
                setEditStateIdError("Please Select State");
                isValid = false;
            } else {
                setEditStateIdError("");
            }
        }
        if (item === "nameEn" || item === "both") {
            if (!nameEn || nameEn.trim() === "") {
                setNameEnError("Please Enter English Name");
                isValid = false;
            } else {
                setNameEnError("");
            }
        }
        if (item === "nameHi" || item === "both") {
            if (!nameHi || nameHi.trim() === "") {
                setNameHiError("Please Enter Hindi Name");
                isValid = false;
            } else {
                setNameHiError("");
            }
        }

        return isValid;
    };
    // add district
    const addDistrict = async () => {
        if (!validateForm("both")) return
        try {
            const formData = new FormData();
            formData.append("state_id", editStateId.value)
            formData.append("name_en", nameEn)
            formData.append("name_hi", nameHi)
            const data = await addDistrictData(formData)
            if (data.status == 200) {
                setEditContainer(false)
                setNameEn("")
                setNameHi("")
                setEditStateId("")
                getDistrictData('', "created_at", 1, "desc", "");
                setApiMessage({ type: 'success', message: data?.message });
            } else {
                setApiMessage({ type: 'error', message: data?.message });
            }
        } catch (error) {
            //console.error(error);
            setApiMessage({ type: 'error', message: error?.message });
        }
    }
    // state list
    const getStateList = async () => {
        try {
            const stateDropdownData = await getStateDropdown()
            const data = stateDropdownData?.data?.map(i => ({
                label: i?.name_en, value: i?.id
            }))
            const editData = stateDropdownData?.data?.filter((s) => s.status !== "0")?.map(i => ({
                label: i?.name_en, value: i?.id
            }))
            setStateList(data)
            setEditStateList(editData)
        } catch (error) {
            //console.log("fetch state list", error)
            if (error?.code === "ERR_NETWORK") {
                RemoveSession(navigate);
            }
        };
    };

    const resetFilter = () => {
        setSearchState('')
        getDistrictData('', sortByDistrict, 1, orderByDistrict, searchData);
    }

    const handlePageChange = (selectedPage) => {
        getDistrictData(searchState, sortByDistrict, selectedPage.selected + 1, orderByDistrict, searchData);
    };

    // District list
    const getDistrictData = async (searchedState, sortBy, pageNo, orderBy, searchBy) => {
        try {
            setSearchData(searchBy)
            setOrderByDistrict(orderBy)
            setSortByDistrict(sortBy)
            const districtList = await getDistrictListDataSort(sortBy, orderBy, searchBy, pageNo, searchedState?.value ? searchedState?.value : '')
            setCurrentPage(pageNo > 0 ? pageNo - 1 : pageNo)
            setTotalPages(Math.ceil(districtList?.data?.total / districtList?.data?.per_page));
            const data = districtList?.data?.data
            setDistrictList(data)
            setTableDataLoaded(true)
            setTotalRecords(districtList?.data?.total ? districtList?.data?.total : 0);
        } catch (err) {
            setTotalRecords(0);
            setTableDataLoaded(true)
            //console.log("error on districtList: ", err)
        }
    }

    useEffect(() => {
        //getFontFamily()
        getDistrictData('', "created_at", 1, "desc", "");
        getStateList()
    }, [])

    // delete district
    const deleteDistrict = async (item) => {
        try {
            const formData = new FormData();
            formData.append("district_id", item?.id)
            const data = await deleteDistrictData(formData)
            if (data.status == 200) {
                setEditContainer(false)
                setDeleteData("")
                getDistrictData(searchState, sortByDistrict, currentPage, orderByDistrict, searchData);
            }
        } catch (error) {
            //console.error(error);
        }
    }
    //edit district
    const editDistrict = (item) => {
        setEditData(item)
        setEditStateId(stateList?.find(i => i?.value == item?.state_id))
        setNameEn(item?.name_en);
        setNameHi(item?.name_hi)
        window.scrollTo(0, 0);
    }
    //update district
    const updateDistrict = async () => {
        if (!validateForm("both")) return
        try {
            const formData = new FormData();
            formData.append("state_id", editData?.state_id)
            formData.append("district_id", editData?.id)
            formData.append("name_en", nameEn)
            formData.append("name_hi", nameHi)
            const data = await updateDistrictData(formData)
            if (data.status == 200) {
                handleEditBack();
                setApiMessage({ type: 'success', mmessage: data?.message });
            } else if (data.status == 403) {
                setApiMessage({ type: 'error', message: data?.message });
            } else {
                setApiMessage({ type: 'error', message: data?.message });
            }
        } catch (error) {
            //console.error(error);
            setApiMessage({ type: 'error', message: error?.message });
        }
    }
    const handleEmptyData = () => {
        setEditContainer(false)
        setNameEn("")
        setNameHi("")
        setEditStateId("")
        setNameEnError("")
        setNameHiError("")
        setEditStateIdError("")
        setEditData()
    }
    const handleEnableDisable = async (e, item) => {
        try {
            const formData = new FormData();
            formData.append("district_id", item?.id)
            formData.append("status", e?.value)
            const data = await activeInactiveDistrict(formData)
            if (data?.status == 200) {
                getDistrictData(searchState, sortByDistrict, currentPage + 1, orderByDistrict, searchData);
            } else {
                setApiMessage({ type: 'error', message: data.message });
            }
        } catch (error) {
            //console.error(error);
            setApiMessage({ type: 'error', message: error?.message });
        }
    }

    const handleEditBack = async () => {
        setEditContainer(false)
        setSearchData('')
        setCurrentPage(1)
        setSearchState('')
        setNameEnError('')
        setNameHiError('')
        setEditStateIdError('')
        setSearchTerm("")

        setSortByDistrict('name_en')
        setOrderByDistrict('asc')
        getDistrictData('', "created_at", 1, "desc", "");
    }

    const handleInputChange = async (e) => {
        const { name, value } = e.target;
        const cursorPosition = e.target.selectionStart;

        // Check for "nameEn" field
        if (name === "nameEn") {

            if (await checkPattern(value)) {
                setNameEnError("")
                setNameEn(value);
            } else {
                e.preventDefault()
                return;
            }
        }

        // Check for "nameHi" field
        if (name === "nameHi") {
            if (await checkPattern(value)) {
                setNameHiError("")
                setNameHi(value);
            } else {
                e.preventDefault()
                return;
            }
        }

        setTimeout(() => {
            e.target.setSelectionRange(cursorPosition, cursorPosition);
        }, 0);
    };

    return (
        <AdminDashboard>
            <div className='aod-outer'>
                {apiMessage && (<Message apiMessage={apiMessage} setApiMessage={setApiMessage}></Message>)}
                {editContainer ? <>
                    <div className='ap-breadcrumb pt-2 pb-2 mb-2 adm-breadcrumb'>
                        <div>
                            <HomeIcon /><b onClick={() => navigate("/admin/")}>Home  /</b>   <span>Districts</span>

                        </div>
                    </div>
                    <div className="aod-inner">
                        <div className={editData?.id ? "aod-update aod-bottom" : "aod-bottom"}>
                            <div className="aod-head text-center adm-head"> <button onClick={() => handleEditBack()}><BsChevronLeft /> Back</button>{editData?.id ? "Update" : "Add"} District</div>
                            <div className="row py-4">
                                <div className="col-md-4 aod-resp-tab">
                                    <div className='suf-input-box aod-form-input mb-2'>
                                        <label className='lf-label w-100'>
                                            Select State
                                        </label>
                                        <Select
                                            styles={customStylesAcc}
                                            theme={selectTheme}
                                            components={{
                                                IndicatorSeparator: () => null
                                            }}
                                            className='menu_open_select'
                                            classNamePrefix='ad-menu_open_select_class'
                                            aria-label="Default select example"
                                            isDisabled={editData?.id}
                                            value={editStateId}
                                            options={editSateList}
                                            onChange={(e) => { setEditStateId(e); setEditStateIdError("") }}
                                            placeholder="Select State"
                                            onMenuOpen={() => handleKeyUpLoginDetails("stateId")}
                                            onMenuClose={() => handleKeyUpLoginDetails("stateId")}
                                        />
                                        {editStateIdError && <p className='validate-error'>{editStateIdError}</p>}
                                    </div>
                                </div>
                                <div className="col-md-4 aod-resp-tab">
                                    <div className='suf-input-box aod-form-input mb-2'>

                                        <label className='mb-1 w-100'>
                                            English Name
                                        </label>
                                        <input className='w-100' placeholder='Enter English Name' type="text" name="nameEn" value={nameEn} maxLength={80} onChange={handleInputChange} />

                                        {nameEnError && <p className='validate-error'>{nameEnError}</p>}

                                    </div>
                                </div>
                                <div className="col-md-4 aod-resp-tab">
                                    <div className='suf-input-box aod-form-input mb-2'>

                                        <label className='mb-1 w-100'>
                                            Hindi Name
                                        </label>
                                        <input className='w-100' placeholder='Enter Hindi Name' type="text" name="nameHi" value={nameHi} maxLength={80} onChange={handleInputChange} />

                                        {nameHiError && <p className='validate-error'>{nameHiError}</p>}
                                    </div>
                                </div>
                            </div>
                            <div className="row ad-cat-row">
                                <div className=" update-btns-block">
                                    {
                                        editData?.id ?
                                            <>

                                                <button onClick={() => updateDistrict()}>
                                                    Update
                                                </button> </> :

                                            <button onClick={addDistrict}>
                                                Submit
                                            </button>
                                    }
                                </div>
                            </div>

                        </div>
                    </div>
                </> :
                    <>
                        <div className='ap-breadcrumb pt-2 pb-2 mb-2 adm-breadcrumb'>
                            <div>
                                <HomeIcon /><b onClick={() => navigate("/admin/")}>Home  /</b>   <span>Districts</span>

                            </div>
                            {(grantPermissionForAddDistrict) ? (
                                <button className='adm-tab-btn' onClick={() => {
                                    handleEmptyData()
                                    setEditContainer(true)
                                }}><span><HiPlus />
                                    </span> Add</button>
                            ) : ''}
                        </div>
                        <div className="aod-inner pt-0">
                            <div className="aod-bottom">
                                <div className="adm-tabs-outer d-flex justify-content-between d-md-flex justify-content-between">
                                    <h4 className='mb-0 w-100'>Districts</h4>
                                    <div className='suf-input-box aod-form-input mb-2 ms-3 w-50'>
                                        {/* <input className='w-100 form-control' placeholder='search' type="text"
                                            onChange={(e) => {
                                                const trimmedValue = e.target.value.trim(); // Trim the input value
                                                getDistrictData(searchState, sortByDistrict, 1, orderByDistrict, trimmedValue)
                                            }}
                                            onPaste={(e) => {
                                                e.preventDefault();  // To prevent the default behaviour
                                                const pastedData = e.clipboardData.getData('Text').trim();
                                                document.execCommand('insertText', false, pastedData); // To paste the trimmed value in input box 
                                            }}
                                        /> */}
                                        <div className="position-relative w-100">
                                            <input
                                                className="px-2 form-control"
                                                placeholder="Search"
                                                type="text"
                                                value={searchTerm} // Add a state for the input value
                                                onChange={(e) => {
                                                    setSearchTerm(e.target.value);
                                                    const trimmedValue = e.target.value.trim(); // Trim the input value
                                                    getDistrictData(searchState, sortByDistrict, 1, orderByDistrict, trimmedValue)
                                                }}
                                                onPaste={(e) => {
                                                    e.preventDefault();  // To prevent the default behaviour
                                                    const pastedData = e.clipboardData.getData('Text').trim();
                                                    document.execCommand('insertText', false, pastedData); // To paste the trimmed value in input box 
                                                }}
                                            />
                                            {searchTerm && ( // Show the clear button only when there's text
                                                <button
                                                    className="btn btn-clear position-absolute"
                                                    onClick={(e) => {
                                                        setSearchTerm(""); // Clear the input value
                                                        getDistrictData(searchState, sortByDistrict, 1, orderByDistrict, '') // Fetch data with empty search term
                                                    }}
                                                    style={{
                                                        top: "50%",
                                                        right: "10px",
                                                        transform: "translateY(-50%)",
                                                        border: "none",
                                                        background: "transparent",
                                                        fontSize: "1rem",
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    &times; {/* This is the "X" icon */}
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="aod-head"></div>
                                <div className="row py-4">
                                    <div className="col-md-4 aod-resp-tab">
                                        <div className='suf-input-box aod-form-input mb-2'>
                                            <Select
                                                styles={customStylesAcc}
                                                theme={selectTheme}
                                                components={{
                                                    IndicatorSeparator: () => null
                                                }}
                                                className='menu_open_select w-100'
                                                classNamePrefix='ad-menu_open_select_class'
                                                aria-label="Default select example"
                                                value={searchState}
                                                options={stateList}
                                                onChange={(e) => {
                                                    setSearchState(e);
                                                    getDistrictData(e, sortByDistrict, 1, orderByDistrict, searchData)
                                                }}
                                                placeholder="Select State"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <button onClick={resetFilter} className='ad-reset-btn w-auto px-4'>
                                            Reset
                                        </button>
                                    </div>
                                    <TotalRecords totalRecords={totalRecords}></TotalRecords>
                                </div>

                                <div className="ad-reg-table">
                                    <Table size="sm" className='ad-cat-table'>
                                        <thead>
                                            <tr>
                                                <th className='ad-sno'>S. No</th>
                                                <th className='ad-long cursor-pointer' onClick={(e) => getDistrictData(searchState, 'name_en', currentPage + 1, orderByDistrict == 'asc' ? 'desc' : 'asc', searchData)}>English Name <span><i className="fa-solid fa-sort"></i></span></th>
                                                <th className='ad-long cursor-pointer' onClick={(e) => getDistrictData(searchState, 'name_hi', currentPage + 1, orderByDistrict == 'asc' ? 'desc' : 'asc', searchData)}>Hindi Name <span><i className="fa-solid fa-sort"></i></span></th>
                                                <th className='ad-long cursor-pointer' onClick={(e) => getDistrictData(searchState, 'state_name_en', currentPage + 1, orderByDistrict == 'asc' ? 'desc' : 'asc', searchData)}>State Name <span><i className="fa-solid fa-sort"></i></span></th>
                                                <th className='ad-long cursor-pointer' onClick={(e) => getDistrictData(searchState, 'created_at', currentPage + 1, orderByDistrict == 'asc' ? 'desc' : 'asc', searchData)}>Created At <span><i className="fa-solid fa-sort"></i></span></th>
                                                {(grantPermissionForEditDistrict) ? (<>
                                                    <th className='ad-long'>Status</th></>
                                                ) : ''}
                                                {grantPermissionForEditDistrict || grantPermissionForDeleteDistrict ? (<>
                                                    <th className='ad-long'>Actions</th></>
                                                ) : ''}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                districtList?.length > 0 ? districtList?.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{(currentPage * 10) + (index + 1)}</td>
                                                        <td>{item?.name_en}</td>
                                                        <td>{item?.name_hi}</td>
                                                        <td>{stateList?.find(i => i.value == item?.state_id)?.label}</td>
                                                        <td>{item?.created_at ? formatDateWithSlash(item?.created_at) : '--'}</td>
                                                        {(grantPermissionForEditDistrict) ? 
                                                            <td>
                                                                <label className="switch">
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={item?.status == 1}
                                                                        onChange={(e) => handleEnableDisable(e.target.checked ? { value: "1" } : { value: "0" }, item)}
                                                                    />
                                                                    <span className="slider"></span>
                                                                </label>
                                                            </td> : <></>}

                                                            {/* <td>
                                                            <div className="action-btn d-flex"><span className='ad-cat-edit' onClick={() => { editDistrict(item); setEditContainer(true) }}><EditIcon /></span><span className='ad-cat-delete' onClick={() => setDeleteData(item)}><DeleteIcon /></span></div></td> */}

                                                            <td>
                                                                <div className="action-btn d-flex">
                                                                {(grantPermissionForEditDistrict) ? 
                                                                    <OverlayTrigger
                                                                        placement="top"
                                                                        overlay={<Tooltip id={`edit-tooltip-${item.id}`}>Edit</Tooltip>}
                                                                    >
                                                                        <span
                                                                            className="ad-cat-edit"
                                                                            onClick={() => { editDistrict(item); setEditContainer(true) }}
                                                                        >
                                                                            <EditIcon />
                                                                        </span>
                                                                    </OverlayTrigger> : <></>}
                                                                    {(grantPermissionForDeleteDistrict) ? 
                                                                    <OverlayTrigger
                                                                        placement="top"
                                                                        overlay={<Tooltip id={`delete-tooltip-${item.id}`}>Delete</Tooltip>}
                                                                    >
                                                                        <span className='ad-cat-delete' onClick={() => setDeleteData(item)}><DeleteIcon /></span>
                                                                    </OverlayTrigger> : <></>}
                                                                </div>
                                                            </td>
                                                    </tr>
                                                )) : tableDataLoaded ? <NotFoundTable colSpan="6"></NotFoundTable> : <></>
                                            }
                                        </tbody>
                                    </Table>
                                    {totalPages > 1 && districtList?.length > 0 &&
                                        <div className="d-flex w-100 justify-content-end">
                                            <ReactPaginate
                                                previousLabel={"Previous"}
                                                nextLabel={"Next"}
                                                breakLabel={"..."}
                                                pageCount={totalPages} // Total number of pages from API
                                                marginPagesDisplayed={1}
                                                pageRangeDisplayed={1}
                                                onPageChange={handlePageChange} // Method to handle page click
                                                containerClassName={"pagination justify-content-center"} // Custom CSS classes
                                                pageClassName={"page-item"}
                                                pageLinkClassName={"page-link"}
                                                previousClassName={"page-item"}
                                                previousLinkClassName={"page-link"}
                                                nextClassName={`page-item${!districtList?.length > 0 ? ' disabled' : ''}`}
                                                nextLinkClassName={"page-link"}
                                                breakClassName={"page-item"}
                                                breakLinkClassName={"page-link"}
                                                activeClassName={"active"}
                                                forcePage={currentPage}
                                            />
                                        </div>

                                    }
                                </div>
                            </div>
                        </div>
                    </>
                }
            </div>
            <Modal show={deleteData?.id} onHide={() => setDeleteData("")}>
                <Modal.Header closeButton>
                    <Modal.Title style={{ fontSize: '19px' }} >Are you sure you want to delete this district ?</Modal.Title>
                </Modal.Header>
                <Modal.Footer>
                    <div className="suf-btn p-2">
                        <button onClick={() => { deleteDistrict(deleteData) }}>Yes</button>
                        <button className='suf-can-butt no-btn' onClick={() => setDeleteData("")}>No</button>
                    </div>
                </Modal.Footer>
            </Modal>
        </AdminDashboard>
    )
}

export default Districts